import { render, staticRenderFns } from "./NlpLogoMobile.vue?vue&type=template&id=17282e7f"
import script from "./NlpLogoMobile.vue?vue&type=script&lang=js"
export * from "./NlpLogoMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports